import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, empty } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HPService } from '../../services/hp.service';

@Injectable()
export class HPResolver implements Resolve<Observable<string>> {

  constructor(
    private hpService: HPService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    return this.hpService.get().pipe(map(
      (res) => {
        return JSON.stringify(res);
      }),
      catchError(err => {
        return empty();
      }
    ));
  }

}
